import React from 'react'

const Refundpolicy = () => {
    return (
        <div>
            <strong>Refund Policy</strong>
            <p>This Refund and Cancellation Policy governs all cancellations, refund requests,
                and dispute handling for any product or service purchased through the Platform.
                By placing an order on the Platform, you agree to the terms of this policy:</p>
                <li>
                    <strong>Scope</strong>
                    <ul>
                        <li>
                            This Refund and Cancellation Policy governs all cancellations, refund requests, and dispute
                            handling for any product or service purchased through the Platform.
                        </li>
                        <li>
                            By placing an order on the Platform, you agree to the terms of this policy.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Cancellation Policy</strong>
                    <ul>
                        <li>
                            Cancellations will only be considered if the request is made within <strong> 5 days </strong> of placing the order.
                        </li>
                        <li>
                            Cancellation requests may not be entertained if the orders have already been communicated
                            to the seller(s) / merchant(s) listed on the Platform, or the product/service has been
                            dispatched, delivered, or activated.
                        </li>
                        <li>
                            Once the order is processed by the seller/merchant, cancellation may no longer be possible,
                            irrespective of whether you have used the product/service.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>General Refund Policy</strong>
                    <ul>
                        <li>
                            Alareet Enterprises &amp; Fyjix generally does <strong> not </strong> accept refund requests.
                        </li>
                        <li>
                            Refunds may only be considered in cases of:
                            <ul>
                                <li>Payment failures or double charges.</li>
                                <li>Technical issues that prevent you from accessing the purchased product or service.</li>
                            </ul>
                        </li>
                        <li>
                            All refund requests must be supported with valid proof of payment and transaction details.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Defective Outputs or Service Issues</strong>
                    <ul>
                        <li>
                            In case of receipt of defective outputs, incomplete service, or non-functional products,
                            you must report the issue to our customer service team.
                        </li>
                        <li>
                            Such issues must be reported within <strong> 5 days </strong> of receipt/activation of the product or service.
                        </li>
                        <li>
                            The request will be forwarded to the concerned seller/merchant listed on the Platform.
                            Any resolution or refund will be considered only after the seller/merchant has checked
                            and determined the defect at its end.
                        </li>
                        <li>
                            If you feel that the product or service received is not as shown on the site or not as per
                            your expectations, you must notify our customer service team within <strong> 5 days </strong> of receipt.
                        </li>
                        <li>
                            After reviewing your complaint, the customer service team will decide the appropriate
                            course of action, which may include replacement, correction, or denial of refund, at its
                            sole discretion.
                        </li>
                        <li>
                            Complaints raised after 5 days of receipt may not be eligible for any form of refund,
                            replacement, or compensation.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Refund Processing</strong>
                    <ul>
                        <li>
                            In case of any refunds approved by Alareet Enterprises, it will take up to
                            <strong> 3 days </strong> for the refund to be processed.
                        </li>
                        <li>
                            Refunds will be made only to the original payment method used for the purchase.
                        </li>
                        <li>
                            The time taken for the refunded amount to reflect in your account may vary depending
                            on your bank or payment provider.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Non-Refundable Cases</strong>
                    <ul>
                        <li>
                            No refunds will be provided if:
                            <ul>
                                <li>You change your mind after purchase.</li>
                                <li>You are unable to use the product/service due to personal reasons or lack of technical knowledge.</li>
                                <li>The dissatisfaction arises from incorrect use or misuse of the product/service.</li>
                            </ul>
                        </li>
                        <li>
                            Digital, subscription-based, or access-based products/services are strictly non-refundable
                            once activated, unless a verified technical or payment issue is established from our side.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Dispute Resolution</strong>
                    <ul>
                        <li>
                            In case of payment disputes, we may request supporting documents, screenshots,
                            or transaction references from you for verification.
                        </li>
                        <li>
                            Alareet Enterprises &amp; Fyjix reserves the right to approve or reject any refund claim
                            after internal investigation.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Acceptance of Policy</strong>
                    <ul>
                        <li>
                            By placing an order or using the Platform, you confirm that you have read, understood,
                            and agreed to this Refund and Cancellation Policy.
                        </li>
                        <li>
                            Continued use of the Platform after any updates to this policy will be deemed as acceptance
                            of the revised terms.
                        </li>
                    </ul>
                </li>

        </div>
    )
}

export default Refundpolicy